//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('domObjectTypes', {
//        templateUrl: 'views/components/views/domObjectTypes/domObjectTypes.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'ttGridFactory', function (stateService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                gridReady: true
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_domobjecttypes_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            })
//                .setToolbar({ wrapping: true })
//                .setLoadDataFunction({
//                    method: 3016,
//                    parameters: {}
//                })
//                .setCustomToolbarButtons([{
//                    name: 'domobjecttypes_new',
//                    text: 'domobjecttypes_new',
//                    func: () => stateService.go('domobjecttype', { domobjecttype_keyno: '0' }),
//                    icon: 'fa-plus',
//                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
//                    translate: true
//                }]);
            
//            // #endregion VARIABLES & DEFINITIONS
            
//        }]
//    });
//})();
